module.exports = __webpack_public_path__ + "static/scale-model-of-omaha-visitors-center-in-omaha-nebraska-77c081147bc83aefc143e1a08ed0d259.png";